import { useEffect, useState } from "react";
import {
  DashBoardChartTopLeft,
  DashBoardChartTopRight,
  FooterFilterMobile,
  LoaderCustom,
  StatisticalRight,
  SumStatistical,
} from "../../components";
import { Select, Tooltip } from "antd";
import {
  useAuthStore,
  useRevenueEachMonth,
  useRevenueOverall,
} from "../../store";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";
import { useGetTotalErrorApi } from "../../hooks/record-transaction/useGetTotalErrorTransactionApi";
import useDebounce from "../../hooks/common/useDebounce";
import { useNavigate } from "react-router-dom";
import path from "../../ultils/path";
import { formatToVND } from "../../helper";
import FooterMobile from "../../components/common/FooterMobile";

const listYear = [
  {
    value: 2023,
    label: "2023",
  },
  {
    value: 2024,
    label: "2024",
  },
  {
    value: 2025,
    label: "2025",
  },
  {
    value: 2026,
    label: "2026",
  },
];

const TEST_ID = "685bcdd8-97e2-44b7-a9d1-591190f6b4db";
const ERROR_ID = "6e11385b-9fb2-4eff-9439-bd56b197c034";

const StatisticalPage = () => {
  const [isLoader, setLoader] = useState(false);
  const [searchStoreCode, setSearchStoreCode] = useState("");
  const [searchQuery, setSearchQuery] = useState<string>(""); // State for search query

  const debouncedSearchQuery = useDebounce(searchQuery, 600);

  const { token } = useAuthStore();

  const NAV = [
    {
      label: "TEST",
      id: TEST_ID,
    },
    {
      label: "ERROR",
      id: ERROR_ID,
    },
  ];

  useEffect(() => {
    setResultId(ERROR_ID);
  }, []);

  // year current
  const currentDate = new Date();
  const yearCurrent = currentDate.getFullYear();

  const { setYear, year } = useRevenueEachMonth();

  const { totalError, setTotalError, setStoreCode, resultId, setResultId } =
    useRevenueOverall();

  const { totalError: totalErrorApi } = useGetTotalErrorApi(searchStoreCode);

  const navigate = useNavigate();

  useEffect(() => {
    if (totalErrorApi) {
      setTotalError(totalErrorApi?.data);
    }
  }, [totalErrorApi]);

  useEffect(() => {
    setSearchStoreCode(searchQuery);
  }, [debouncedSearchQuery]);

  useEffect(() => {
    if (!token) {
      navigate(path.SIGN_IN);
    }
  }, []);

  return (
    <>
      {/* {isLoader && <LoaderCustom></LoaderCustom>} */}

      <div className=" h-[100%] p-[20px] lg:p-[0px] flex flex-col xl:gap-6 lg:gap-5 md:gap-3 gap-2">
        <div
          className="relative w-[100%] h-fit" // Điều chỉnh chiều cao ở đây
        >
          <SumStatistical />
        </div>

        <div className="flex max-lg:flex-col xl:gap-6 lg:gap-5 md:gap-3 gap-2 h-full">
          <div className="lg:w-[75%] h-full flex flex-col xl:gap-6 lg:gap-5 md:gap-3 gap-3 max-md:mt-5">
            <div className="flex max-lg:flex-col items-start lg:h-[65%] xl:gap-6 lg:gap-5 md:gap-3 gap-2">
              {/* revenue month */}
              <div className="lg:w-1/2 lg:p-4 p-2 lg:gap-4 gap-2 max-lg:w-[100%] h-full max-lg:h-[60vh] flex-col bg-white shadow-lg rounded-lg flex justify-center items-end overflow-hidden">
                <div className="flex w-full items-center justify-between">
                  <span className="font-normal lg:text-base text-gray-800 text-sm">
                    Revenue Monthly
                  </span>
                  <div className="flex justify-between">
                    <Select
                      defaultValue={year ? year : yearCurrent}
                      style={{ width: 100 }}
                      allowClear
                      onChange={(e) => {
                        setYear(e);
                      }}
                      options={listYear}
                      placeholder="select year"
                    />
                  </div>
                </div>
                <DashBoardChartTopRight></DashBoardChartTopRight>
              </div>
              {/* revenue each store */}
              <div className="max-md:mt-3 lg:p-4 p-2 bg-white lg:w-1/2 h-full max-lg:w-[100%] max-lg:h-[60vh] flex-col rounded-lg flex justify-center shadow-lg overflow-hidden">
                <span className="font-normal lg:text-base text-gray-800 text-sm mb-2">
                  Revenue Each Store
                </span>
                <DashBoardChartTopLeft></DashBoardChartTopLeft>
              </div>
            </div>
            {/* add code ======= */}
            <div className="lg:w-[25%] max-md:mt-4 lg:hidden h-full bg-white 2xl:p-[16px] xl:p-[14px] lg:p-[10px] p-[6px] rounded-lg shadow">
              <StatisticalRight></StatisticalRight>
            </div>
            {/* <FooterMobile></FooterMobile> */}
          </div>
          <div className="lg:w-[25%] max-lg:hidden h-full bg-white 2xl:p-[16px] xl:p-[14px] lg:p-[10px] p-[6px] rounded-lg shadow">
            <StatisticalRight></StatisticalRight>
          </div>
        </div>
      </div>
      <FooterFilterMobile></FooterFilterMobile>
    </>
  );
};

export default StatisticalPage;
